// 本地兜底翻译；线上翻译走 CDN（MTS），需在 MTS 后台补齐 Fund.WireCurrencyNotSupported
export const Fund = {
    WireCurrencyNotSupported: '該收款賬戶幣種暫不支持出金，請更換賬戶或新增幣種為 USD、GBP、EUR 的電匯賬戶',
};
